<template>
  <div class="flex gap-2">
    <img
      class="w-10 dark:invert"
      src="/assets/logo-icon.svg"
      alt="Logo Icon"
    />
    <img
      class="w-52 dark:invert"
      src="/assets/logo-text.svg"
      alt="Logo Text"
    />
  </div>
  
</template>
